import React, { useEffect, useState, useRef } from "react";
import DOMPurify from "dompurify";
import { Link } from "react-router-dom";
import { useAuth } from "./../context/AuthContent";
import { getAllProducts, GetAllMainCategoriesFunc } from "./../api/index";
import { getBackendAssetsUrl } from "./../config/Production";
import { addToCartLocal } from "./../config/commonfunctions/AddToCart";
import ProductPricing from "./Components/ProductPricing";
import LoaderComponent from "./../components/Loader/LoaderComponent";

export default function Shop() {
  const { refreshCartCount } = useAuth();
  const [backurl, setBackUrl] = useState("");
  const [mainCategories, setMainCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const loaderRef = useRef(null);

  useEffect(() => {
    if (!loaderRef.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && hasMore && !loading) {
          loadProducts();
        }
      },
      {
        root: null,
        rootMargin: "200px",
        threshold: 0.1,
      },
    );

    observer.observe(loaderRef.current);

    return () => observer.disconnect();
  }, [hasMore, loading]);

  const loadProducts = async () => {
    if (!hasMore || loading) return;

    setLoading(true);
    const res = await getAllProducts({ offset, limit: 12 });

    if (res.data.products.length === 0) {
      setHasMore(false);
      setLoading(false);
      return;
    }

    setProducts((prev) => {
      const newProducts = res.data.products.filter(
        (p) => !prev.some((existing) => existing.id === p.id),
      );
      return [...prev, ...newProducts];
    });
    setOffset(res.data.next_offset);
    setHasMore(res.data.has_more);
    setLoading(false);
  };

  const MainCategoryFetch = async () => {
    const res = await GetAllMainCategoriesFunc();

    setMainCategories(res.data.data);
  };

  useEffect(() => {
    loadProducts();
    MainCategoryFetch();
    setBackUrl(getBackendAssetsUrl());
  }, []);

  return (
    <section className="prt-row shop-section clearfix">
      <div className="container">
        {/* Page Header */}
        <div className="section-title title-style-center_text mb-40">
          <div className="title-header">
            <h2 className="cta-title">Bharat Dhara Store</h2>
            <h4 className="cta-titlepre">
              Farm to Plate • Ayurveda • Wellness
            </h4>
          </div>
        </div>

        {/* Filter Row */}
        <div className="row mb-30 align-items-center">
          <div className="col-md-6">
            <select className="form-select w-auto">
              <option>All Categories</option>
              {mainCategories.length > 0 &&
                mainCategories.map((item, index) => {
                  return (
                    <option key={index} value={item.id}>
                      {item.category_name}
                    </option>
                  );
                })}
            </select>
          </div>

          <div className="col-md-6 text-md-end mt-2 mt-md-0">
            <select className="form-select d-inline-block w-auto">
              <option>Sort by Latest</option>
              <option>Price: Low to High</option>
              <option>Price: High to Low</option>
            </select>
          </div>
        </div>

        {/* Products Grid */}
        <div className="row row-equal-height">
          {products.length > 0
            ? products.map((product, i) => {
                const ProductImagesArr = product.product_images.split("|");
                const randomIndex = Math.floor(
                  Math.random() * ProductImagesArr.length,
                );
                const randomImage = ProductImagesArr[randomIndex];
                const folderName = product.product_name
                  .toLowerCase()
                  .replaceAll(" ", "_");

                return (
                  <div key={i} className="col-lg-3 col-md-4 col-sm-6 mb-30">
                    <div className="featured-imagebox featured-imagebox-product style1">
                      <div className="featured-thumbnail">
                        <img
                          src={`${backurl}shop_product_listing/${folderName}/${randomImage}_medium.webp`}
                          alt={product.product_name}
                          className="img-fluid"
                        />
                      </div>

                      <div className="featured-content">
                        <div className="featured-title">
                          <h3>
                            <a href={`/product${product.product_url}`}>
                              {product.product_name}
                            </a>
                          </h3>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(
                                product.short_description,
                              ),
                            }}
                          ></p>
                        </div>

                        <div className="featured-desc">
                          <p>
                            <ProductPricing ProductPrice={product.price} />
                          </p>
                        </div>

                        <div className="prt-product-btn">
                          <Link
                            className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor mr"
                            to={`/product${product.product_url}`}
                          >
                            View
                          </Link>
                          <button
                            className="prt-btn prt-btn-size-sm prt-btn-shape-round prt-btn-style-border prt-btn-color-darkcolor"
                            onClick={async () => {
                              addToCartLocal(product);
                              await refreshCartCount();
                            }}
                          >
                            Add to Cart
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
        {/* Scroll Trigger */}
        <div ref={loaderRef} style={{ height: "1px" }}></div>

        {/* Loading / End message */}
        {loading && <LoaderComponent />}
        {!hasMore && (
          <div className="text-center my-4">
            <span>No more products</span>
          </div>
        )}
      </div>
    </section>
  );
}
